export { Fade as DSFade, type FadeProps as DSFadeProps } from '@material-ui/core';
